import Vue from 'vue';
import callViewDialog from '@/components/callView.vue';

const callViewDialogPlugin = {
  install(Vue) {
    // 创建组件构造器
    const DialogConstructor = Vue.extend(callViewDialog);
    let instance;

    // 全局方法：打开弹窗
    function $showCallViewDialog() {
      if (!instance) {
        // 创建实例并挂载到 body
        instance = new DialogConstructor();
        instance.$mount();
        document.body.appendChild(instance.$el);
      }
      // 返回 Promise 以便获取用户操作
      return instance.callViewShow();
    }

    function $hideCallViewDialog() {
        if (!instance) {
          // 创建实例并挂载到 body
          instance = new DialogConstructor();
          instance.$mount();
          document.body.appendChild(instance.$el);
        }
        // 返回 Promise 以便获取用户操作
        return instance.callViewHide();
      }

      function $showPeerViewDialog() {
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
          return instance.peerViewShow();
      }
      function $hidePeerViewDialog() {
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
          return instance.peerViewHide();

      }
      
      function $showAudioTipWrapDialog(){
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
          return instance.audioTipWrapShow();
      }

      function $hideAudioTipWrapDialog(){
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
          return instance.audioTipWrapHide();
      }

      function $showLocalViewDialog(){
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
          return instance.localViewShow();
      }

      function $hideLocalViewDialog(){
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
          return instance.localViewHide();
      }

      function $showVideoPeerDialog(){
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
          return instance.videoPeerShow();
      }

      
      function $hideVideoPeerDialog(){
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
          return instance.videoPeerHide();
      }

      function $showAudioPeerDialog(){
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
          return instance.audioPeerShow();
      }

      function $hideAudioPeerDialog(){
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
          return instance.audioPeerHide();
      }


      function $showVideoLocalDialog() {
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
        return instance.videoLocalShow();
      }
      function $hideVideoLocalDialog() {
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
        return instance.videoLocalHide();
      }
      function $showAudioLocalDialog() {
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
        return instance.audioLocalShow();
      }
      function $hideAudioLocalDialog() {
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
        return instance.audioLocalHide();
      }

      function $getMute(muteName,muteIcon) {
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
        return instance.getMute(muteName,muteIcon);
      }
      function $getCall(modeName,modeIcon) {
        if (!instance) {
            // 创建实例并挂载到 body
            instance = new DialogConstructor();
            instance.$mount();
            document.body.appendChild(instance.$el);
          }
          // 返回 Promise 以便获取用户操作
        return instance.getCall(modeName,modeIcon);
      }
    // 挂载到 Vue 原型
    Vue.prototype.$showCallViewDialog = $showCallViewDialog;
    Vue.prototype.$hideCallViewDialog = $hideCallViewDialog;
    Vue.prototype.$showPeerViewDialog = $showPeerViewDialog;
    Vue.prototype.$hidePeerViewDialog = $hidePeerViewDialog;
    Vue.prototype.$showAudioTipWrapDialog = $showAudioTipWrapDialog;
    Vue.prototype.$hideAudioTipWrapDialog = $hideAudioTipWrapDialog;
    Vue.prototype.$showLocalViewDialog = $showLocalViewDialog;
    Vue.prototype.$hideLocalViewDialog = $hideLocalViewDialog;
    Vue.prototype.$showVideoPeerDialog = $showVideoPeerDialog;
    Vue.prototype.$hideVideoPeerDialog = $hideVideoPeerDialog;
    Vue.prototype.$showAudioPeerDialog = $showAudioPeerDialog;
    Vue.prototype.$hideAudioPeerDialog = $hideAudioPeerDialog;
    Vue.prototype.$showVideoLocalDialog = $showVideoLocalDialog;
    Vue.prototype.$hideVideoLocalDialog = $hideVideoLocalDialog;
    Vue.prototype.$showAudioLocalDialog = $showAudioLocalDialog;
    Vue.prototype.$hideAudioLocalDialog = $hideAudioLocalDialog;
    Vue.prototype.$getMute = $getMute;
    Vue.prototype.$getCall = $getCall;
  }
};

export default callViewDialogPlugin;